import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <section className="not-found page-section">
      <div className="shell">
        <span className="eyebrow">404</span>
        <h1>Bu rota henüz haritada yok.</h1>
        <p>Aradığın sayfa taşınmış veya adres yanlış yazılmış olabilir.</p>
        <Link className="button button-primary" to="/">Ana sayfaya dön</Link>
      </div>
    </section>
  );
}
